export default {
  'app.setting.pagestyle': 'Paramètre de style de page',
  'app.setting.pagestyle.dark': 'Style sombre',
  'app.setting.pagestyle.light': 'Style clair',
  'app.setting.content-width': 'Largeur du contenu',
  'app.setting.content-width.fixed': 'Fixe',
  'app.setting.content-width.fluid': 'Fluide',
  'app.setting.themecolor': 'Couleur du thème',
  'app.setting.themecolor.dust': 'Rouge poussière',
  'app.setting.themecolor.volcano': 'Volcan',
  'app.setting.themecolor.sunset': 'Orange coucher de soleil',
  'app.setting.themecolor.cyan': 'Cyan',
  'app.setting.themecolor.green': 'Vert polaire',
  'app.setting.themecolor.daybreak': 'Bleu aube (par défaut)',
  'app.setting.themecolor.geekblue': 'Bleu geek',
  'app.setting.themecolor.purple': 'Violet doré',
  'app.setting.navigationmode': 'Mode de navigation',
  'app.setting.sidemenu': 'Mise en page menu latéral',
  'app.setting.topmenu': 'Mise en page menu supérieur',
  'app.setting.fixedheader': 'En-tête fixe',
  'app.setting.fixedsidebar': 'Barre latérale fixe',
  'app.setting.fixedsidebar.hint': 'Fonctionne avec la mise en page menu latéral',
  'app.setting.hideheader': 'En-tête masqué lors du défilement',
  'app.setting.hideheader.hint': 'Fonctionne quand l\'en-tête masqué est activé',
  'app.setting.othersettings': 'Autres paramètres',
  'app.setting.weakmode': 'Mode convivial pour daltoniens',
  'app.setting.copy': 'Copier les paramètres',
  'app.setting.copyinfo':
    'copie réussie, veuillez remplacer defaultSettings dans src/models/setting.js',
  'app.setting.production.hint':
    'Le panneau de paramètres ne s\'affiche qu\'en environnement de développement, veuillez modifier manuellement',
};